const COOKIE_PATH = '/'

function escapeCookieName(name: string): string {
  return name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null
  }

  try {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${escapeCookieName(name)}=([^;]*)`),
    )
    return match ? decodeURIComponent(match[1]) : null
  } catch {
    return null
  }
}

export function setCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
): void {
  if (typeof document === 'undefined') {
    return
  }

  try {
    const secure = import.meta.env.PROD ? '; Secure' : ''
    document.cookie = `${name}=${encodeURIComponent(value)}; path=${COOKIE_PATH}; SameSite=Lax; Max-Age=${maxAgeSeconds}${secure}`
  } catch {
    // Cookie API unavailable or blocked — auth helpers must not crash the app.
  }
}

export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') {
    return
  }

  try {
    const secure = import.meta.env.PROD ? '; Secure' : ''
    document.cookie = `${name}=; path=${COOKIE_PATH}; SameSite=Lax; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT${secure}`
  } catch {
    // Cookie API unavailable or blocked — auth helpers must not crash the app.
  }
}
